import React from "react";
import { Container } from "reactstrap";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { YearComponent } from "../common/calendar/YearComponent";
import { MonitoringDTO } from "../../../types/Monitoring";

interface Props {
  issuedMonitoring: MonitoringDTO[];
  cancelledMonitoring: MonitoringDTO[];
  gettingIssuedMonitoring: boolean;
  gettingCancelledMonitoring: boolean;
  getIssuedInvoicesMonitoring: (year: number) => void;
  getCancelledInvoicesMonitoring: (year: number) => void;
}

interface State {
  year: number;
}

/**
 * Pantalla METADATA SAT.
 * Dos calendarios: facturas emitidas y facturas canceladas.
 * Consume el BFF (mismo flujo que el resto de pantallas).
 */
class Monitoring extends React.Component<Props, State> {
  state = {
    year: moment().year()
  };

  componentDidMount() {
    this.loadYear(this.state.year);
  }

  loadYear = (year: number) => {
    this.props.getIssuedInvoicesMonitoring(year);
    this.props.getCancelledInvoicesMonitoring(year);
  };

  onChangeYear = (year: number) => {
    this.setState({ year });
    this.loadYear(year);
  };

  renderLegend() {
    return (
      <div style={{ margin: "16px 0", textAlign: "center" }}>
        <span
          className="sw-calendar date monitoring monitoring-status-1"
          style={{ pointerEvents: "none" }}
        >
          &nbsp;
        </span>
        <span style={{ margin: "0 16px 0 4px", fontSize: "0.85rem" }}>
          Correcto
        </span>
        <span
          className="sw-calendar date monitoring monitoring-status-2"
          style={{ pointerEvents: "none" }}
        >
          &nbsp;
        </span>
        <span style={{ margin: "0 16px 0 4px", fontSize: "0.85rem" }}>
          Advertencia
        </span>
        <span
          className="sw-calendar date monitoring monitoring-status-3"
          style={{ pointerEvents: "none" }}
        >
          &nbsp;
        </span>
        <span style={{ margin: "0 16px 0 4px", fontSize: "0.85rem" }}>
          Error
        </span>
        <span
          className="sw-calendar date monitoring monitoring-status-none"
          style={{ pointerEvents: "none" }}
        >
          &nbsp;
        </span>
        <span style={{ margin: "0 0 0 4px", fontSize: "0.85rem" }}>
          Sin eventos
        </span>
      </div>
    );
  }

  renderCalendar(
    loading: boolean,
    statuses: MonitoringDTO[],
    idPrefix: string
  ) {
    if (loading) {
      return (
        <div style={{ textAlign: "center" }}>
          Espere un momento por favor <br />
          <span style={{ fontSize: "1.4em" }}>
            <FontAwesomeIcon icon={faSpinner} pulse />
          </span>
        </div>
      );
    }

    return (
      <div style={{ textAlign: "center" }}>
        <YearComponent
          id={`${idPrefix}-${this.state.year}`}
          year={this.state.year}
          submitter={{}}
          selected={[]}
          onChangeYear={this.onChangeYear}
          soportaAlterna={false}
          monitoringMode
          statuses={statuses}
        />
      </div>
    );
  }

  render() {
    return (
      <Container>
        <div style={{ margin: "16px 0" }}>
          <strong>Monitoreo de facturas emitidas.</strong> Cada día se colorea
          según su estatus.
        </div>
        {this.renderLegend()}
        {this.renderCalendar(
          this.props.gettingIssuedMonitoring,
          this.props.issuedMonitoring,
          "issued"
        )}

        <hr style={{ margin: "32px 0" }} />

        <div style={{ margin: "16px 0" }}>
          <strong>Monitoreo diario de facturas canceladas.</strong> Cada día se
          colorea según su estatus.
        </div>
        {this.renderLegend()}
        {this.renderCalendar(
          this.props.gettingCancelledMonitoring,
          this.props.cancelledMonitoring,
          "cancelled"
        )}
      </Container>
    );
  }
}

export default Monitoring;
